<div class="flex flex-col items-center m-4 h-full overflow-auto">

    <!-- Dialog Boxes -->
    <div class="flex justify-center">
        <p-dialog modal="true" header="Add User" [(visible)]="showAddUserForm"  [style]="{ width: '400px' }">
            <app-add-user-form [showAdminInputs]="user?.profile?.isGlobalAdmin" [companies]="companies"
                [(userProfile)]="addUserAccount" (userUpdated)="onUserAdd($event)" [user]="user"
                (emailChanged)="onUserEmailChanged($event)" [showPassword]="userNotInAuth0"
            />
        </p-dialog>

        <p-dialog modal="true" header="Edit User" [(visible)]="showEditUserForm"  [style]="{ width: '400px' }">
            <app-edit-user-form [showAdminInputs]="user?.profile?.isGlobalAdmin" [companies]="companies"
                [userProfile]="editUserAccount" (userUpdated)="onUserEdit($event)"
                [user]="user"
            />
        </p-dialog>

        <p-dialog modal="true" header="Edit Permissions" [(visible)]="showEditPermissionsForm"  [style]="{ width: '400px' }">
            <app-edit-permissions-form [userPermissions]="userPermissions"
                (permissionsUpdated)="onUserPermissionsUpdated($event)"
            />
        </p-dialog>
    </div>

    <p-card class="flex m-4 p-4 w-max">

        <!-- Card Header -->
        <ng-template pTemplate="title">
            <h1 class="text-center mt-2">
                Users
            </h1>
            <p-button class="ml-2" (click)="showAddUser()" icon="pi pi-user" label="Add User" outlined="true"></p-button>
            <hr class="my-4" />
        </ng-template>

        <div class="flex flex-col p-4">
            <!-- Entra-ID Info Banner -->
            <div class="mb-4 p-4 surface-ground border-l-4 border-primary rounded">
                <div class="flex flex-col space-y-2">
                    <div class="font-semibold flex items-center">
                        <i class="pi pi-info-circle mr-2"></i>
                        Entra-ID Managed Users
                    </div>
                    <div class="text-sm">
                        Users marked <strong>[Entra-ID]</strong> have their access managed by your IT department through Active Directory.
                    </div>
                    <ul class="text-sm list-disc ml-6 space-y-1">
                        <li>New users will appear here after their first login</li>
                        <li>Removed users may still appear in this list (they cannot log in)</li>
                        <li>To view current active users, check the Auth0 Dashboard</li>
                        <li>To add/remove users or change roles, contact your IT department</li>
                    </ul>
                </div>
            </div>

            <app-tool-loader [isLoading]="isLoading()">
                <app-users-table 
                    [users]="users" (userEdited)="showEditUser($event)" (userRemoved)="removeUser($event)"
                    (permissionsEdited)="showEditPermissions($event)" (licenseToggled)="toggleLicense($event)"
                    (inviteSent)="sendInvite($event)" 
                    (viewDesigns)="openUserDesignsDialog($event)" [user]="user"
                />
            </app-tool-loader>
        </div>

    </p-card>

</div>